import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { SearchForm } from "@/components/header/SearchForm";
import { DesktopNav } from "@/components/header/DesktopNav";
import { MobileNav } from "@/components/header/MobileNav";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const close = () => setMobileOpen(false);
  const handleLogout = async () => { await logout(); navigate("/"); };

  return (
    <header className="border-b-2 border-black sticky top-0 bg-white z-50" data-testid="site-header">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-3 flex items-center gap-3 md:gap-8">
        <Link to="/" onClick={close} className="font-brand text-2xl md:text-4xl leading-none text-black no-underline hover:no-underline shrink-0" data-testid="brand-link">
          marketcraig<span className="text-[#0000EE]">.</span>
        </Link>
        <SearchForm variant="desktop" />
        <DesktopNav user={user} onLogout={handleLogout} />
        <button data-testid="mobile-menu-toggle" onClick={() => setMobileOpen((o) => !o)} className="md:hidden ml-auto border-2 border-black p-2 bg-white hover:bg-black hover:text-white" aria-label="Toggle menu">
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      <SearchForm variant="mobile" onDone={close} />
      {mobileOpen && <MobileNav user={user} onClose={close} onLogout={handleLogout} />}
    </header>
  );
}
